import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Button, Grid, Link, Paper, Stack, Typography } from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const TaxExempt = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS Nonprofit Tax Forms, Schedules & Guides | TaxZerone"
          description="From Form 990 instructions to Form 5227 compliance, state filings to 990-T schedules - TaxZerone is your complete hub for every exempt organization filing."
          keywords=""
          canonical="resources/tax-exempt/"
          ogType="article"
          jsonLdPricing="19.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="3830"
        />
      }
    >
      <Container
        maxWidth="lg"
        sx={{
          justifyContent: 'center',

          mt: 8,
          mb: 8,
        }}
        component="section"
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              backgroundColor: '#ffebf1',
              px: 2,
              py: 0.5,
              textAlign: 'center',
              justifyContent: 'center',
              alignContent: 'center',
              display: 'inline-block',
              borderRadius: 4,
              border: '1px solid #c02652',
              color: '#c02652',
              gap: 1,
              mx: 0,
            }}
          >
            <Box
              component="span"
              sx={{
                width: 8,
                height: 8,
                minWidth: 8,
                borderRadius: '50%',
                backgroundColor: '#c02652',
                display: 'inline-block',
                gap: 2,
                animation:
                  'pulseDot 3.8s cubic-bezier(0.5, 0, 0.6, 1) infinite',

                '@keyframes pulseDot': {
                  '0%': {
                    transform: 'scale(0.5)',
                    boxShadow: '0 0 0 0 rgba(192, 38, 82, 0.5)',
                  },
                  '50%': {
                    transform: 'scale(1.1)',
                    boxShadow: '0 0 0 7px rgba(192, 38, 82, 0)',
                  },
                  '100%': {
                    transform: 'scale(0.5)',
                    boxShadow: '0 0 0 0 rgba(192, 38, 82, 0)',
                  },
                },
              }}
            />
            &nbsp; Nonprofit & Tax-Exempt Organization Resources
          </Typography>
        </Box>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 2,
            mt: 5,
            textAlign: 'center',
          }}
        >
          Everything You Need to Understand, Prepare, and File{' '}
          <span className="highlight-container">
            <span className="highlight">Tax-Exempt </span>
          </span>{' '}
          Organization Returns
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { md: 18, sm: 16, xs: 16 },
            textAlign: 'center',
            mb: 2,
          }}
        >
          Step-by-step instructions, deadline guides, compliance tools, and
          schedule <br /> references -all in one place for tax-exempt
          organizations.
        </Typography>

        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href="#explore"
          >
            Explore Resources
          </Button>
        </Box>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
          scrollMarginTop: 64,
        }}
        spacing={2}
        m={0}
        mt={0}
        component="section"
        id="explore"
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={3}
            rowSpacing={4}
            m={0}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Getting started with Form 990
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Explore essential nonprofit tax forms, filing instructions, and
                requirements to help you identify and <br /> complete the right
                IRS return for your organization.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-n-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                      left: 15,
                    }}
                  >
                    Essentials
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 990 -N Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Understand the e-Postcard filing process for small
                      tax-exempt organizations - including eligibility
                      thresholds, required fields, and annual due dates.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      See 990-N Requirements
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-ez-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                      left: 15,
                    }}
                  >
                    Important dates
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 990-EZ Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Find out who qualifies to file Form 990-EZ, what
                      information is required, and how to complete each part of
                      this simplified nonprofit return.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Explore Form 990-EZ</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                      left: 15,
                    }}
                  >
                    Most helpful
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 990 Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Get clear, step-by-step guidance on Form 990 filing
                      requirements, key sections, schedules, and what nonprofits
                      must report to the IRS each year.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Explore Form 990</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-pf-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                      left: 15,
                    }}
                  >
                    Most helpful
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 990-PF Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Private foundations have unique IRS reporting obligations.
                      Get detailed guidance on completing Form 990-PF, from
                      investment income to distributable amounts.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Review Form 990-PF Instructions
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-t-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 990-T Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Tax-exempt organizations with unrelated business income
                      must file Form 990-T. Learn what qualifies as UBI, how to
                      calculate tax owed, and how to file correctly.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">990-T Requirements</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box component="section" sx={{ my: 8 }}>
        <Container maxWidth="lg">
          <Grid
            container
            spacing={3}
            rowSpacing={4}
            m={0}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Split-Interest Trust Forms
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Explore key forms, schedules, and filing requirements for
                split-interest trusts, including charitable remainder and
                charitable lead trusts.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-5227-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                    }}
                  >
                    Payment
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 5227 Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Split-interest trusts - including charitable remainder and
                      charitable lead trusts - must file Form 5227. Get complete
                      instructions on distributions, assets, and compliance.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Read Form 5227 Instructions
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-5227-filing-due-dates/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                    }}
                  >
                    Technology
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 5227 Due Dates
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Split-interest trusts must file Form 5227 by specific IRS
                      deadlines. Get the key dates, extension options, and what
                      happens if you miss the filing window.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">View 5227 Due Dates</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-5227-penalties/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                    }}
                  >
                    Technology
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 5227 Penalties
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Missing a Form 5227 filing deadline or reporting errors
                      can result in IRS penalties for split-interest trusts.
                      Find out what the penalties are and how to avoid them.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Check 5227 Penalties
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-5227-schedule-e/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                    }}
                  >
                    Technology
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule E (1040)
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Learn how split-interest trusts report income from rents,
                      royalties, partnerships, S corporations, estates, trusts,
                      and REMICs using Schedule E (Form 1040).
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Explore Schedule E</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box component="section" sx={{ backgroundColor: '#f0f2f9' }}>
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Grid
            container
            spacing={3}
            rowSpacing={4}
            m={0}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Political Organization Forms
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Find the forms and reporting requirements political
                organizations need to meet their federal tax and disclosure
                obligations.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-1120-pol-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                      left: 15,
                    }}
                  >
                    Compliance
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 1120-POL Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Political organizations subject to tax on investment
                      income file Form 1120-POL. Get clear instructions on who
                      must file, what income is taxable, and how to report it.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Explore 1120-POL Instructions
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-1120-pol-filing-due-dates/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                      left: 15,
                    }}
                  >
                    Compliance
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 1120-POL Due Date
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Find Form 1120-POL due dates for calendar- and fiscal-year
                      organizations, along with extension information.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Check Form 1120-POL Due Dates
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box component="section" sx={{ backgroundColor: '#fff' }}>
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Grid
            container
            spacing={3}
            rowSpacing={4}
            m={0}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                State Tax-Exempt Forms
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Navigate state-level tax-exempt filings, reporting requirements,
                and annual compliance obligations for nonprofit organizations.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/ftb-ca-form-199-filing/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                      left: 15,
                    }}
                  >
                    Most helpful
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      FTB CA Form 199 Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      California nonprofits must file Form 199 with the
                      Franchise Tax Board. Get state-specific instructions on
                      who must file, what to include, and when it's due.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      CA Form 199 Instructions
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-109-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  {/* <Typography
                    variant="body1"
                    sx={{
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

                      zIndex: 2,
                      position: 'absolute',
                      fontSize: { md: 13, sm: 12, xs: 11 },
                      borderRadius: 24,
                      backgroundColor: '#e7f8ed',
                      color: '#1da94a',
                      fontWeight: 500,
                      border: '1px solid #1da94a',
                      px: 2,
                      display: 'inline-block',
                      top: -12,
                      left: 15,
                    }}
                  >
                    Most helpful
                  </Typography> */}

                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      CA Form 109 Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      California exempt organizations with unrelated business
                      income file Form 109 with the FTB. Understand the state's
                      rules for UBI reporting and how they differ from federal
                      requirements.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Navigate CA Form 109 Instructions
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/ftb-form-3885f-depreciation/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      FTB Form 3885F Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      California exempt organizations use FTB Form 3885F to
                      report depreciation and amortization with the Franchise
                      Tax Board. Get clear instructions and file your state
                      return accurately!
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      mt: 2,
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Explore FTB Form 3885F Instructions
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/ftb-form-3885/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      FTB Form 3885 Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Report depreciation and amortization deductions on your
                      California state return using FTB Form 3885. Understand
                      how state rules differ from federal and file without
                      errors.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      mt: 2,
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      View FTB Form 3885 Instructions
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-ftb-3509-guide/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      FTB Form 3509 Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      California organizations claiming the Political or
                      Legislative Activities Credit file FTB Form 3509 with the
                      Franchise Tax Board. Find out who qualifies and how to
                      claim it correctly!
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      mt: 2,
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Review FTB Form 3509 Requirements
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/schedule-d-541/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule D (541) Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      California estates, trusts, and applicable exempt
                      organizations use Schedule D (541) to report capital gains
                      and losses from the sale or exchange of capital assets.
                      Find clear 2025 instructions for completing each part of
                      the schedule.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      mt: 2,
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      View Schedule D (541) Instructions
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/schedule-p-100/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule P (100) Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      California corporations and eligible exempt organizations
                      use Schedule P (100) to calculate AMT and credit
                      limitations. Find clear 2025 instructions for each part
                      and line.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      mt: 2,
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      View Schedule P (100) Instructions
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box component="section" sx={{ backgroundColor: '#f0f2f9' }}>
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Grid
            container
            spacing={3}
            rowSpacing={4}
            m={0}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Form Comparisons
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Compare nonprofit tax forms side by side to determine which
                return applies to your organization based on filing
                <br />
                requirements, income, assets, and activities.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-vs-form-990-ez/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 990 vs Form 990-EZ
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Not sure which form your nonprofit needs to file? Compare
                      Form 990 and Form 990-EZ side by side - including gross
                      receipts thresholds, total asset limits, and reporting
                      differences.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Compare 990 vs 990-EZ
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-n-vs-form-990-ez/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 990-N vs Form 990-EZ
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Small nonprofits often qualify for either Form 990-N or
                      990-EZ - but the differences matter. See which filing
                      applies to your organization based on revenue, assets, and
                      activity.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Compare 990-N vs 990-EZ
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box component="section" sx={{ backgroundColor: '#fff' }}>
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Grid
            container
            spacing={3}
            rowSpacing={4}
            m={0}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Tax-Exempt Status &amp; Applications
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Learn how organizations apply for tax-exempt status and
                understand the forms, requirements, and responsibilities that
                follow.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-1023/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 1023
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Applying for 501(c)(3) status starts with Form 1023. Learn
                      what the IRS requires, how to describe your organization's
                      purpose, and what to expect after submission.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Form 1023 Overview</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/501c3-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      501(c)(3) Tax-Exempt Status
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Understand the rules, responsibilities, and annual filing
                      requirements that come with 501(c)(3) tax-exempt status -
                      from public charity tests to prohibited activity
                      restrictions.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Explore 501(c)(3) Requirements
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid
              size={{ xs: 12, md: 12, sm: 12 }}
              sx={{ mt: 3, borderTop: '1px solid #ccc' }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                  mt: 5,
                }}
              >
                Deadlines & Mailing
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Stay on track with key nonprofit filing deadlines, extension
                dates, and mailing information for federal tax-exempt
                organization returns.
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-due-dates/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 990 Series Due Dates
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Never miss a filing deadline. Find due dates for Form 990,
                      990-EZ, 990-N, 990-PF, and 990-T - including extension
                      deadlines organized by fiscal year end.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      mt: 2,
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">View 990 Due Dates</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-mailing-address/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 990 Mailing Address
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Know exactly where to send your paper Form 990. Find the
                      correct IRS mailing address based on your organization's
                      location and the form type you're filing.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      mt: 2,
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Find Mailing Details
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box component="section" sx={{ backgroundColor: '#f0f2f9' }}>
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Grid
            container
            spacing={3}
            rowSpacing={4}
            m={0}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Form 990 Schedules
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Explore Form 990 schedules and learn what organizations must
                report about finances, activities, contributions,
                <br /> compensation, and related entities.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-a/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule A
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Most public charities must complete Schedule A to document
                      their public support test results. Learn what each part
                      covers and which calculation method applies to your
                      organization.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Schedule A Requirements
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-b/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule B
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Schedule B reports significant contributors to tax-exempt
                      organizations. Understand the $5,000 threshold rule, what
                      must be disclosed, and important confidentiality
                      protections.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Understand Schedule B
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-c/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule C
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Organizations engaged in political campaigns or lobbying
                      activities complete Schedule C. Find out what types of
                      political and legislative activities trigger this
                      schedule.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Explore Schedule C</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-d/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule D
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Schedule D provides supplemental financial data for
                      organizations that report certain types of assets,
                      liabilities, or activities on their 990. See what
                      additional details are required.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">View Schedule D</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-f/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule F
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Nonprofits with activities or grantmaking outside the
                      United States file Schedule F. Get instructions on
                      reporting foreign activities, expenditures, and recipient
                      organizations.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">See Schedule F</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-g/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule G
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Organizations that conduct fundraising events or gaming
                      activities complete Schedule G. Learn which revenue
                      thresholds trigger the schedule and what detail must be
                      reported.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Learn about Schedule G
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-i/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule I
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Nonprofits that make grants to individuals or domestic
                      organizations file Schedule I. Understand the reporting
                      thresholds, required recipient information, and how to
                      aggregate grants.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Explore Schedule I</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-j/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule J
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Organizations that pay substantial compensation to
                      officers, directors, or key employees complete Schedule J.
                      Learn what triggers the requirement and how to report each
                      component correctly.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Complete Schedule J</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-k/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule K
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Tax-exempt organizations with outstanding tax-exempt bonds
                      file Schedule K to disclose bond proceeds, use of funds,
                      and private business use. Understand the thresholds and
                      required data.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">See Schedule K</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-l/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule L
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Schedule L discloses transactions between the organization
                      and its interested persons - including loans, grants, and
                      business deals. Learn what must be reported and the dollar
                      thresholds involved.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">See Schedule L</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-m/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule M
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Organizations that receive noncash contributions above
                      certain thresholds complete Schedule M. Learn how
                      different types of property - from art to intellectual
                      property - must be reported.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Report Schedule M</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-n/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule N
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      When a nonprofit dissolves, terminates, or transfers
                      significant assets, Schedule N is required. Understand
                      what events trigger it, what information must be
                      disclosed, and how to attach it.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">See Schedule N</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-o/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule O
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Schedule O provides supplemental narrative explanations
                      for many Form 990 line items. Learn what questions require
                      additional context and how to write responses that satisfy
                      IRS reviewers.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Learn About Schedule O
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-schedule-r/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule R
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Organizations with related entities - including
                      disregarded entities, partnerships, and other controlled
                      organizations - complete Schedule R. Learn what
                      relationships must be disclosed and how.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Learn Schedule R</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box component="section" sx={{ backgroundColor: '#fff' }}>
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Grid
            container
            spacing={3}
            rowSpacing={4}
            m={0}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Form 990-T Related Forms & Schedules
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Understand the related forms and schedules used to report
                unrelated business income, deductions, credits, gains, and
                taxable activities.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-t-schedule-a/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      990-T Schedule A
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Schedule A of Form 990-T reports unrelated business
                      taxable income from each separate business activity. Learn
                      how to identify qualifying income streams and allocate
                      deductions correctly.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Explore 990-T Schedule A
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/schedule-d-form-1120-guide/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      1120 Schedule D
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Form 1120's Schedule D reports capital gains and losses
                      for corporations, including tax-exempt organizations
                      subject to UBI tax. Understand how to classify and report
                      each transaction.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Report 1120 Schedule D
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/schedule-d-form-1041-resource-guide/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      1041 Schedule D
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Trusts and estates filing Form 1041 use Schedule D to
                      report capital gain income. Learn how gains are
                      categorized, taxed, and how carryover losses are applied.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Understand 1041 Schedule D
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/1041-schedule-i-amt/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      1041 Schedule I
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Schedule I of Form 1041 calculates Alternative Minimum Tax
                      for trusts and estates. Get the instructions for
                      determining AMT adjustments, preferences, and the
                      tentative minimum tax.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Calculate AMT with 1041 Schedule I
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-4797-sales-business-property/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 4797
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Form 4797 reports sales of business property, including
                      real estate and depreciable assets. Understand the
                      different sections, how depreciation recapture applies,
                      and how gains are taxed.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">File Form 4797</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-4562-depreciation-amortization-guide/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 4562
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Form 4562 is used to claim depreciation, amortization, and
                      Section 179 deductions. Learn what property qualifies, how
                      bonus depreciation works, and how to complete each part.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Claim Depreciation Deductions on Form 4562
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-8050-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 8050
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Form 8050 is used by corporations to request a direct
                      deposit of tax refunds. Learn when this form is required
                      and how to ensure your organization's refund is processed
                      correctly.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Request Direct Deposit with Form 8050
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-8949-sales-and-dispositions-guide/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 8949
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Form 8949 reports individual capital asset transactions
                      before they flow to Schedule D. Understand how cost basis,
                      proceeds, and adjustments are reported for each
                      transaction.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Explore Form 8949</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-8995-qualified-business-income-deduction/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 8995
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Form 8995 calculates the qualified business income
                      deduction for eligible taxpayers. Find out which income
                      qualifies, how limitations are applied, and where the
                      deduction flows on your return.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Calculate Your QBI Deduction on Form 8995
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-2220-underpayment-estimated-tax-corporations/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 2220
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Learn how Form 2220 is used to calculate underpayment of
                      estimated tax penalties for corporations and certain
                      tax-exempt organizations, including organizations subject
                      to tax on unrelated business income.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Explore Form 2220</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-3800-business-credits/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 3800
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Form 3800 is the General Business Credit form,
                      consolidating multiple credits into one place. Learn which
                      credits must flow through Form 3800 and how the carryback
                      and carryforward rules work.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Learn more Form 3800
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-3468-investment-credit/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 3468
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Form 3468 calculates the Investment Credit, including
                      credits for rehabilitation of historic structures and
                      energy property. Learn what qualifies, how credit amounts
                      are calculated, and how to claim them.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Form 3468</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-8911-alternative-fuel-credits/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 8911
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Learn about Form 8911 and the Alternative Fuel Vehicle
                      Refueling Property Credit, including eligibility
                      requirements and recent changes affecting property placed
                      in service after June 30, 2026.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">File Form 8911</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-8936-clean-vehicle-credit/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 8936
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Form 8936 calculates credits for qualified plug-in
                      electric drive motor vehicles and clean vehicles. Learn
                      the eligibility requirements, credit amounts by vehicle
                      category, and how to apply them to your return.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Explore Form 8936</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-3800-schedule-a/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Schedule A (Form 3800){' '}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Schedule A of Form 3800 is used to claim the current year
                      general business credit from specific activities.
                      Understand how it separates passive activity credits from
                      non-passive credits and how they offset tax.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Report Schedule A (Form 3800)
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box component="section" sx={{ backgroundColor: '#f0f2f9' }}>
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Grid
            container
            spacing={3}
            rowSpacing={4}
            m={0}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Compliance
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Understand important nonprofit compliance requirements,
                including penalties, automatic revocation, state filings,
                <br /> and additional IRS reporting obligations.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-990-penalties/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Forms 990 Penalties
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Failing to file on time - or filing incorrectly - can
                      trigger IRS penalties against your nonprofit. Understand
                      the penalty amounts, how they accrue, and how to request
                      abatement.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">Check 990 Penalties</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/automatic-revocation-of-tax-exempt-status/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Automatic Revocation
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      The IRS automatically revokes tax-exempt status when a
                      nonprofit fails to file for three consecutive years. Learn
                      what triggers revocation, what it means, and how to
                      reinstate.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Learn About Revocation
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/transfer-election-statement/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Transfer Election Statement
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Certain charitable trusts must file a Transfer Election
                      Statement with the IRS when trust assets change. Get
                      guidance on when this is required and what must be
                      included.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">See Filing Rules</Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/ca-form-rrf1-filing-guide/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form RRF-1
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      California nonprofits registered with the Attorney General
                      must file Form RRF-1 annually. Learn about the filing
                      requirements, required attachments, and how it relates to
                      your 990.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Explore RRF-1 Filing
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid
              size={{ xs: 12, md: 12, sm: 12 }}
              sx={{ mt: 3, borderTop: '1px solid #ccc' }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 20, xs: 18 },
                  fontWeight: 600,
                  mb: 0.5,
                  mt: 5,
                }}
              >
                Passive Activity & Loss Limitations
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Learn how passive activity rules limit losses and deductions,
                and understand the forms used to calculate and report these
                amounts.
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Link
                href="/resources/tax-exempt/form-8582-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2,
                    position: 'relative',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 3,
                    pt: 3,
                    pb: 2,
                    minHeight: '100%',
                    justifyContent: 'center',
                    display: 'grid',
                    alignContent: 'space-between',
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover .css-e1jxyz-MuiSvgIcon-root': {
                      transform: 'rotate(-225deg)',
                    },
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                      transform: 'translateY(-0.1rem)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 22, sm: 19, xs: 16 },
                        mb: 0.5,
                      }}
                    >
                      Form 8582 Instructions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Learn how Form 8582 is used to calculate and report
                      limitations on passive activity losses and determine the
                      amount of loss that may be deductible for the tax year.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'left',
                      textAlign: 'left',
                      mt: 2,
                      gap: 1.2,
                      color: '#0202ff',
                    }}
                  >
                    <Typography variant="body1">
                      Form 8582 requirements
                    </Typography>
                    <KeyboardBackspaceIcon
                      sx={{
                        transform: 'rotate(-180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Container
        maxWidth="lg"
        sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}
        component="section"
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography variant="body1">
              TaxZerone — Your Tax- Exempt Filing Partner
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Nonprofits, Trusts & Political Organizations - TaxZerone Covers
              Every Exempt Filing
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 2,
              }}
            >
              From public charities to private foundations, charitable trusts to
              political organizations - TaxZerone simplifies <br /> the entire
              exempt filing process so you can focus on your mission, not your
              paperwork!
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=taxexempt`}
              >
                Get Started Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default TaxExempt;
